if (!customElements.get('lox-corporate-reveal')) {
  class LoxCorporateReveal extends HTMLElement {
    connectedCallback() {
      this.animations = new Set();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.finishMotion = () => { if (this.motion.matches) this.animations.forEach(animation => animation.finish()); };
      if (this.motion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          const animation = entry.target.animate(
            [{opacity: 0, transform: 'translateY(18px)'}, {opacity: 1, transform: 'translateY(0)'}],
            {duration: 650, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'none'}
          );
          this.animations.add(animation);
          animation.finished.then(() => this.animations.delete(animation)).catch(() => this.animations.delete(animation));
        });
      }, {threshold: 0.08, rootMargin: '0px 0px -30px 0px'});
      this.querySelectorAll('[data-lox-reveal]').forEach(element => this.observer.observe(element));
      this.motion.addEventListener('change', this.finishMotion);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.finishMotion);
      this.animations?.forEach(animation => animation.cancel());
    }
  }
  customElements.define('lox-corporate-reveal', LoxCorporateReveal);
}
